import { useClientCreditVouchers } from 'service-api/src/hooks/use_client_vouchers'
import type { VoucherFilterParams } from 'service-api/src/services/admin_voucher.service'

interface UsePackageCreditsProps {
  locationName: string
  locationUserProfileId: string
  enabled: boolean
}

export const usePackageCredits = ({ locationName, locationUserProfileId, enabled }: UsePackageCreditsProps) => {
  const baseParams = {
    enabled,
    locationUserProfile: locationUserProfileId,
    type: 'OFFER',
    status: 'ACTIVE',
  } as VoucherFilterParams

  const { data: available, isLoading: isLoadingAvailable } = useClientCreditVouchers(
    locationName,
    {
      ...baseParams,
      atLeastOneAvailable: true,
      expired: false,
      isUsed: false,
    },
    true
  )

  const { data: redeemed, isLoading: isLoadingRedeemed } = useClientCreditVouchers(
    locationName,
    {
      ...baseParams,
      isUsed: true,
    },
    true
  )

  const { data: expired, isLoading: isLoadingExpired } = useClientCreditVouchers(
    locationName,
    {
      ...baseParams,
      expired: true,
    },
    true
  )

  return {
    available,
    redeemed,
    expired,
    isLoading: isLoadingAvailable || isLoadingRedeemed || isLoadingExpired,
  }
}
